enum VisibilityStatusEnum {
    Hidden = 'HIDDEN',
    Visible = 'VISIBLE',
}

export default VisibilityStatusEnum;
